import React from 'react';
import {
  formatSeparatorPittsburgh,
  formatSeparatorMoscow,
  mostRecentMidnight,
} from '@/lib/formatTimes';

// Date separator. Shows three centered lines (🖤, primary location, other
// location), with a thin horizontal rule UNDER the text. Used:
//   • above the very first post in the feed (changedAt === 'first')
//   • between two posts whenever the date rolls over in either tz
export const DateSeparator = ({ post, changedAt }) => {
  const date = new Date(post.created_at);
  const pgh = formatSeparatorPittsburgh(date);
  const msk = formatSeparatorMoscow(date);

  // Which location is shown on the FIRST text line (line 2, after the 🖤):
  //   'moscow'       -> Moscow's midnight was more recent      -> Moscow on top
  //   'pittsburgh'   -> Pittsburgh's midnight was more recent  -> Pittsburgh on top
  //   'first'        -> very first post in the feed; apply the same
  //                     most-recent-midnight rule based on the post itself.
  const effective = changedAt === 'first' ? mostRecentMidnight(post) : changedAt;
  const moscowFirst = effective !== 'pittsburgh';

  return (
    <li
      className="date-separator"
      role="presentation"
      data-testid="date-separator"
    >
      {changedAt !== 'first' && (
        <div className="date-separator__heart" aria-hidden="true">🖤</div>
      )}
      <div className="date-separator__line">
        {moscowFirst ? msk : pgh}
      </div>
      <div className="date-separator__line">
        {moscowFirst ? pgh : msk}
      </div>
      <hr className="date-separator__rule" />
    </li>
  );
};
